// extracted by mini-css-extract-plugin
export default {"shipmentNoteWrapper":"_6f2db3ad","linkSpace":"_a256d91a","bold":"_8c45739b","error":"_18e89166"};